import { ReactNode } from "react"

export default function Content(props: {
  children: ReactNode
}) {
  return <div className="wrapped">{props.children}</div>
}
